import React, { useCallback } from 'react'
import VideoDuration from 'Components/video/video-duration'
import AuthorAvatar from 'Components/author/author-avatar'
import VideoStats from 'Components/video/video-stats'
import LiveBox from 'Components/video/live-box'
import LiveTag from 'Components/video/live-tag'
import { ILiveRoomItem } from '../../services/home'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image, ImageStyles, ImageZoom } from 'Components/view-image'

interface IProps {
  className?: string
  order?: number
  activeIndex?: number
  data: ILiveRoomItem
  [key: string]: any
}

const Item: React.FC<IProps> = ({
  className,
  data,
  activeIndex,
  order,
  ...props
}) => {
  const handleClick = useCallback(() => {
    sendTeaCommEvent('clk_event', {
      page_id: 'page_main_new',
      event_id: 'live_module_live_item',
      module_id: 'live_module',
      room_id: data.room_id,
      anchor_id: data.user_id,
      rank: `${activeIndex}`,
      item_rank: typeof order === 'number' ? `${order}` : '',
    })
  }, [data.room_id, data.user_id, activeIndex, order])

  return (
    <div className={`live-item ${className ? className : ''}`} {...props}>
      <div className="image-wrap">
        <a
          className="image-link"
          href={`//live.ixigua.com/room/${data.room_id}`}
          target="_blank"
        >
          <ImageZoom zoomHeight="56.25%" onClick={handleClick}>
            <Image
              src={data.cover_url}
              width={512}
              height={288}
              lazy={true}
              className="motor-pc-image-hover"
              alt={data?.title}
            />
          </ImageZoom>
        </a>
        <AuthorAvatar
          avatar={data.avatar}
          username={data.user_name}
          userId={data.user_id}
          userVerified={data.user_verified}
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'live_module_profile',
              module_id: 'live_module',
              room_id: data.room_id,
              anchor_id: data.user_id,
              rank: `${activeIndex}`,
              item_rank: typeof order === 'number' ? `${order}` : '',
            })
          }}
        />
        <LiveBox viewCount={data.popularity} />
        <LiveTag tag={data.city_name} />
      </div>
      <div className="title">
        <a
          className="line-2 g-active-link-text"
          title={data?.title}
          href={`//live.ixigua.com/room/${data.room_id}`}
          target="_blank"
        >
          {data?.title}
        </a>
      </div>
      <style jsx>
        {`
          .live-item {
            display: block;
            overflow: hidden;
            position: relative;
            margin-bottom: 8px;
          }
          .live-item:last-child {
            margin-right: 0;
          }
          .image-wrap {
            position: relative;
            line-height: 0;
          }
          .image-link {
            display: block;
            border-radius: 2px;
            overflow: hidden;
          }
          .title {
            padding: 33px 8px 15px;
          }
          .title a {
            font-size: 16px;
            font-weight: 500;
            color: #1f2129;
          }
          .live-item:hover .image-link {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
          .live-item:hover .title {
            border-radius: 2px;
            background-color: #ffffff;
          }
        `}
      </style>
    </div>
  )
}

export default Item
